import React from 'react';

import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  IconButton,
  Switch,
  CloseIcon,
} from '@gogame/components';
import {
  FormField,
  withFormFieldGroupFormField,
  withFormField,
} from '@gogame/form';

import { TimeLimitInput } from 'scenes/PromoCodes/components/PromoCodesForm/components';
import {
  IS_TIME_LIMITED,
  CUSTOM_TIMER,
  REWARDS,
  TIMER,
} from 'scenes/PromoCodes/constants';

import Rewards from '../Rewards';

const TimeLimitSwitch = withFormField({ padding: 0 })(({
  name,
  value,
  onChange,
  form,
}) => {
  const { values } = form;

  const handleChange = (_e, val) => {
    let value = {
      [IS_TIME_LIMITED]: val,
      [TIMER]: null,
    };
    onChange(_e, value);
  };

  return (
    <Switch
      name={name}
      label={'Custom completion time'}
      disabled={!values?.conditions?.isTimeLimited}
      checked={!!value?.isTimeLimited}
      onChange={handleChange}
    />
  );
});

const ConditionalRewardCard = withFormFieldGroupFormField({ padding: 0 })(({
  title,
  onRemove,
  value,
  rewards,
}) => {
  return (
    <Card elevation={6}>
      <CardHeader
        title={
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <FormField.TextField
                label={title}
                required={true}
                name={'value'}
                type={'number'}
                placeholder={'0'}
                padding={'0'}
                maxValue={value?.maxValue}
                minValue={value?.minValue}
              />
            </Grid>
            {value?.customTimer?.isTimeLimited && (
              <Grid item xs={3}>
                <TimeLimitInput name={CUSTOM_TIMER} valuePropKey={'timer'} />
              </Grid>
            )}
            <Grid item xs>
              <div style={{ float: 'right' }}>
                <TimeLimitSwitch name={CUSTOM_TIMER} />
              </div>
            </Grid>
          </Grid>
        }
        action={
          <IconButton
            icon={<CloseIcon />}
            tooltip={'Remove'}
            onClick={onRemove}
          />
        }
      />
      <CardContent>
        <div style={{ paddingTop: 8 }}>
          <Rewards name={REWARDS} data={rewards} />
        </div>
      </CardContent>
    </Card>
  );
});

export default ConditionalRewardCard;
